/**
 * Given a value which may or may not be a number, determine whether to display it.
 * @param {*} number - A value which may or may not be a number.
 * @returns {boolean} - True if we should display the value, false otherwise.
 */
export default function displayNumber(number) {
  return ! Number.isNaN(number) && Number.isFinite(number);
}
